import { getToken, messaging } from "./firebase";

export const requestPermission = async () => {
  try {
    const status = await Notification.requestPermission();

    if (status === "granted") {
      try {
        await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js"
        );
        const serviceWorkerRegistration = await navigator.serviceWorker.ready;
        // Get the FCM token using service worker registration
        const fcmToken = await getToken(messaging, {
          vapidKey:
            "BDXvpKVJefmfPfWs9o96dE5R-6cmdcRmY619fPsZ707HanTMO8KR-wFHrOyUwKgyJlQ0tOoetsUuRckB4LurTuI",
          serviceWorkerRegistration, // Pass service worker registration
        });

        if (fcmToken) {
          localStorage.setItem("device_token", fcmToken);
          return { device_token: fcmToken };
        }
      } catch (error) {
        console.error("Something went wrong!", error);
      }
    } else {
      console.error("Permission denied for notifications");
      return { device_token: null };
    }
  } catch (error) {
    console.error("Error requesting permission", error);
  }
};
